"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _badge = _interopRequireDefault(require("@amzn/meridian-tokens/component/badge"));

var _theme = require("../theme");

var _token = require("./../_utils/token");

var _visuallyHidden = _interopRequireDefault(require("./../_styles/visually-hidden"));

var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _css;

  var type = _ref.type,
      size = _ref.size;
  var sizeOffIcon = t("size", [size, "default"]);
  var sizeOnIcon = t("size", [size, "onIcon"]);
  var borderWidth = t("borderWidth", size);
  return (0, _emotion.css)((_css = {
    display: "inline-flex",

    /**
     * Off-icon styles
     */
    "*:not([role=img]) > &": {
      // Align the container's children towards its top and add a zero-width
      // space character to it. The space character will take on the line
      // height of the badge's parent, forcing the badge container to match
      // that height. The flex alignment will float the actual badge element
      // up to the top of the badge container. This will vertically align the
      // badge with the top of any text that it's placed next to.
      alignItems: "flex-start",
      "&:before": {
        content: "'\\200b'"
      },
      // Off-icon badge styles
      "& > span": {
        fontSize: t("fontSizeDefault"),
        fontWeight: t("fontWeightDefault"),
        lineHeight: "".concat(sizeOffIcon - 2 * borderWidth, "px"),
        height: sizeOffIcon,
        minWidth: sizeOffIcon,
        padding: size === "regular" ? "0 ".concat(t("spacingInsetHorizontalDefault"), "px") : undefined,
        margin: "0 ".concat(t("spacing"), "px")
      }
    }
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] *[role=img] > &", {
    transform: "translateX(50%)",
    left: "inherit",
    right: "calc(100% + ".concat(t("onIconOffset", size), "px - ").concat(sizeOnIcon / 2, "px)")
  }), (0, _defineProperty2["default"])(_css, "*[role=img] > &", {
    position: "absolute",
    top: -t("onIconOffset", size),
    left: "calc(100% + ".concat(t("onIconOffset", size), "px - ").concat(sizeOnIcon / 2, "px)"),
    transform: "translateX(-50%)",
    height: sizeOnIcon,
    // On-icon badge styles
    "& > span": {
      fontSize: t("fontSizeOnIcon"),
      fontWeight: t("fontWeightOnIcon"),
      lineHeight: "".concat(sizeOnIcon - 2 * borderWidth, "px"),
      height: "100%",
      minWidth: sizeOnIcon,
      padding: size === "regular" ? "0 ".concat(t("spacingInsetHorizontalOnIcon"), "px") : undefined
    }
  }), (0, _defineProperty2["default"])(_css, "& > span:first-child", {
    boxSizing: "border-box",
    // Browsers never wrap Arabic numerals, they might try to wrap numerals
    // in other scripts
    textWrap: "nowrap",
    textAlign: "center",
    fontFamily: t("fontFamily"),
    color: t("foregroundColor", type),
    backgroundColor: t("backgroundColor", [size, type]),
    borderWidth: borderWidth,
    borderStyle: "solid",
    borderColor: t("borderColor"),
    borderRadius: t("borderRadius")
  }), (0, _defineProperty2["default"])(_css, "& > span:last-child", _visuallyHidden["default"]), _css));
}, ["type", "size"]);

var getDisplayValue = function getDisplayValue(value, maxValue, locale) {
  return typeof value !== "undefined" ? value > maxValue ? "".concat(maxValue.toLocaleString(locale), "+") : value.toLocaleString(locale) : "";
};
/**
 * Render a small static element that indicates quantity/count.
 */


var Badge = function Badge(props) {
  var value = props.value,
      type = props.type,
      maxValue = props.maxValue,
      locale = props.locale,
      children = props.children;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  var size = value === undefined ? "compact" : "regular";
  var t = (0, _theme.useTheme)(_badge["default"], "badge");
  var displayValue = getDisplayValue(value, maxValue, locale);
  var screenReaderLabel = " ".concat(displayValue, " ");
  if (children) screenReaderLabel += "".concat(children, " ");
  return (
    /*#__PURE__*/
    // NOTE: role="text" is only partially supported in webkit browsers.
    // role="group" did not make a real difference while role="text" improved
    // voice over results for Safari and Chrome on OSX.
    //
    // Tested in Safari and Edge on their respective OSes. Also tested on
    // Chrome + Firefox on  both OSX and PC
    _react["default"].createElement("span", (0, _extends2["default"])({}, passThroughProps, {
      className: styles(t, {
        type: type,
        size: size
      }) // eslint-disable-next-line jsx-a11y/aria-role
      ,
      role: "text"
    }), /*#__PURE__*/_react["default"].createElement("span", {
      "aria-hidden": "true"
    }, displayValue), /*#__PURE__*/_react["default"].createElement("span", null, screenReaderLabel))
  );
};

Badge.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * An accessible label for the badge (read by screen readers but not visible
   * in the UI).
   */
  children: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.30.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * The locale used to display the number in the badge. Any local supported by
   * the [Number.toLocaleString API](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString)
   * will work.
   */
  locale: _propTypes["default"].string,

  /**
   * The maximum number to show in the badge. If the number passed to `value`
   * is greater than this number, then the badge will display something like
   * `"<maxValue>+"` (e.g. `"99+"`).
   *
   * This can be helpful if the value of the badge represents something that may
   * grow without bound (e.g. messages in an inbox), but you want to avoid
   * rendering an extremely long badge (e.g. one with text like
   * `"89,830,342,546"`).
   */
  maxValue: _propTypes["default"].number,

  /**
   * The coloring scheme to use for the badge:
   * - `"theme"` for the current theme's accent color
   * - `"neutral"` for gray-scale coloring
   * - `"error"` for red
   */
  type: _propTypes["default"].oneOf(["theme", "neutral", "error"]),

  /**
   * The number to be shown in the badge. Provide the non-localized value as an
   * actual JavaScript Number type. Omit this prop to render a "compact" badge
   * without a number.
   */
  value: _propTypes["default"].number
} : {};
Badge.defaultProps = {
  type: "theme",
  locale: "en-US"
};
var _default = Badge;
exports["default"] = _default;